module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-panel', [_c('h3', [_vm._v("Activate Your Discovery Vitality Movie Benefit")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.tried) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), (!_vm.success) ? _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.retry()
      }
    }
  }, [_vm._v("Retry")]) : _vm._e(), _vm._v(" "), (_vm.success) ? [_c('p', [_vm._v("You can now use your benefit when booking movies.")]), _vm._v(" "), (_vm.success) ? _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.bookNow()
      }
    }
  }, [_vm._v("Book Now")]) : _vm._e()] : _vm._e()], 2) : _c('sk-form', {
    on: {
      "submit": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('p', [_vm._v("Please fill out your details below.")]), _vm._v(" "), _c('p', [_vm._v("All fields are mandatory.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "label": "Discovery Membership Number",
      "placeholder": "e.g 123456789",
      "required": ""
    },
    model: {
      value: (_vm.discovery.number),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "number", $$v)
      },
      expression: "discovery.number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "label": "Initial of First Name",
      "placeholder": "e.g R",
      "required": "",
      "maxLength": "5"
    },
    model: {
      value: (_vm.discovery.name),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "name", $$v)
      },
      expression: "discovery.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "label": "Your Surname",
      "value": "",
      "placeholder": "e.g Doe",
      "required": ""
    },
    model: {
      value: (_vm.tmp_surname),
      callback: function($$v) {
        _vm.tmp_surname = $$v
      },
      expression: "tmp_surname"
    }
  })], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "select-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "day"
  }, [_c('sk-input', {
    attrs: {
      "placeholder": "Day",
      "max": "31",
      "min": "1",
      "type": "number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter a day'
      }
    },
    model: {
      value: (_vm.discovery.day),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "day", $$v)
      },
      expression: "discovery.day"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "month"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.months,
      "searchable": false,
      "placeholder": "Month",
      "validation-value": _vm.discovery.month,
      "error-message": "Please choose a month",
      "required": ""
    },
    model: {
      value: (_vm.discovery.month),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "month", $$v)
      },
      expression: "discovery.month"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "year"
  }, [_c('sk-input', {
    attrs: {
      "placeholder": "Year",
      "type": "number",
      "required": "",
      "min": _vm.currentYear - 120,
      "max": _vm.currentYear,
      "error-message": {
        valueMissing: 'Please enter a year'
      }
    },
    model: {
      value: (_vm.discovery.year),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "year", $$v)
      },
      expression: "discovery.year"
    }
  })], 1)])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "form-group",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Gender")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('sk-combo-select', {
    attrs: {
      "options": ['Male', 'Female', 'Other'],
      "searchable": false,
      "placeholder": "Gender",
      "validation-value": _vm.discovery.gender,
      "error-message": "Please choose a gender",
      "required": ""
    },
    model: {
      value: (_vm.discovery.gender),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "gender", $$v)
      },
      expression: "discovery.gender"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "email",
      "label": "Email Address",
      "placeholder": "e.g jodndoe@gmail.com",
      "required": ""
    },
    model: {
      value: (_vm.discovery.email),
      callback: function($$v) {
        _vm.$set(_vm.discovery, "email", $$v)
      },
      expression: "discovery.email"
    }
  })], 1), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Activate Discovery Vitality Now")]), _vm._v(" "), _c('p', [_vm._v("There is no activation fee for the digital card.")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd0a4ade","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/discovery-vitality/discovery-vitality.vue
// module id = 605
// module chunks = 0